import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { EmployeeGroupFormValues } from './types';

/**
 * Создаёт zod-схему валидации формы группы операторов.
 * Название обязательно; описание и внешний ID — опциональные.
 */
const createSchema = (t: TFunction<readonly ['common']>) => {
  return z.object({
    name: z.string().min(1, t('common:required')),
    description: z.string().nullish(),
    externalId: z.string().nullish(),
  }) satisfies z.ZodType<EmployeeGroupFormValues>;
};

/**
 * Возвращает локализованную zod-схему формы группы операторов.
 */
export const useEmployeeGroupSchema = () => {
  const { t } = useTranslation(['common']);
  return createSchema(t);
};
